import {ContentCopy as ContentCopyIcon, Psychology as PsychologyIcon, Save as SaveIcon} from "@mui/icons-material";
import {Box, Button, Card, CardContent, Chip, Divider, Grid, Typography} from "@mui/material";
import calcularCosteGemini from "../utils/calcularCosteGemini";

const ResultCard = ({result, onCopy, onSave}) => {
  if (!result) return null;

  const costeGemini = calcularCosteGemini(result.rawResponse.result.usage);

  return (
    <Card sx={{bgcolor: "primary.50", border: 1, borderColor: "primary.200"}}>
      <CardContent>
        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
          <Typography variant="h6" sx={{display: "flex", alignItems: "center", gap: 1}}>
            <PsychologyIcon color="primary" />
            Resultado del Análisis
          </Typography>
          <Box sx={{display: "flex", gap: 1}}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ContentCopyIcon />}
              onClick={onCopy}
              sx={{textTransform: "none"}}
            >
              Copiar
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<SaveIcon />}
              onClick={onSave}
              sx={{textTransform: "none"}}
            >
              Guardar
            </Button>
          </Box>
        </Box>

        <Typography variant="body1" paragraph>
          {result.analysis}
        </Typography>

        <Box sx={{display: "flex", gap: 1, mb: 2, flexWrap: "wrap"}}>
          <Chip label={`Confianza: ${result.confidence}%`} color="primary" size="small" />
          {result.details.fileProcessed && (
            <Chip label={`Archivo: ${result.details.fileProcessed}`} color="secondary" size="small" />
          )}
          {result.details.processingTime && (
            <Chip label={`Tiempo: ${result.details.processingTime}`} color="info" size="small" />
          )}
          {result.rawResponse?.result?.usage && (
            <>
              <Chip
                label={`Tokens: ${result.rawResponse.result.usage.totalTokens.toLocaleString()}`}
                color="warning"
                size="small"
              />
              <Chip label={`Coste: ${costeGemini.costesEUR.total}`} color="success" size="small" />
            </>
          )}
        </Box>

        {result.rawResponse?.result?.usage && (
          <Box
            sx={{
              p: 2,
              mb: 2,
              bgcolor: "success.50",
              borderRadius: 1,
              border: 1,
              borderColor: "success.200"
            }}
          >
            <Typography variant="subtitle2" gutterBottom sx={{fontWeight: "bold", color: "success.800"}}>
              💰 Detalle de Uso - {result.rawResponse.result.model}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Tokens de Entrada
                </Typography>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>
                  {result.rawResponse.result.usage.promptTokens.toLocaleString()}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Tokens de Respuesta
                </Typography>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>
                  {result.rawResponse.result.usage.responseTokens.toLocaleString()}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Tokens de Razonamiento
                </Typography>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>
                  {result.rawResponse.result.usage.thoughtsTokens.toLocaleString()}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Total de Tokens
                </Typography>
                <Typography variant="body2" sx={{fontWeight: "bold", color: "warning.main"}}>
                  {result.rawResponse.result.usage.totalTokens.toLocaleString()}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{my: 2}} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Coste de Entrada
                </Typography>
                <Typography variant="body2">{costeGemini.costesEUR.entrada}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Coste de Salida
                </Typography>
                <Typography variant="body2">{costeGemini.costesEUR.salida}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="textSecondary" display="block">
                  Coste Total
                </Typography>
                <Typography variant="body1" sx={{fontWeight: "bold", color: "success.800"}}>
                  {costeGemini.costesEUR.total}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}

        <Typography variant="caption" color="textSecondary">
          Procesado el {new Date(result.timestamp).toLocaleString()}
        </Typography>

        {result.rawResponse?.data && (
          <Box sx={{mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1}}>
            <Typography variant="caption" color="textSecondary" gutterBottom display="block">
              Datos extraídos:
            </Typography>
            <pre style={{fontSize: "11px", margin: 0, whiteSpace: "pre-wrap"}}>
              {JSON.stringify(result.rawResponse.data, null, 2)}
            </pre>
          </Box>
        )}

        {result.rawResponse && (
          <Box sx={{mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1}}>
            <Typography variant="caption" color="textSecondary" gutterBottom display="block">
              Respuesta completa del servidor (solo en desarrollo):
            </Typography>
            <pre style={{fontSize: "10px", margin: 0, whiteSpace: "pre-wrap"}}>
              {JSON.stringify(result.rawResponse, null, 2)}
            </pre>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ResultCard;
